<script lang="ts" setup>
import { computed } from 'vue';
import BaseButton from '@/atoms/BaseButton.vue';

export type ZoomControllerProps = {
  zoom: number;
  minZoom?: number;
  maxZoom?: number;
  step?: number;
};

const props = withDefaults(defineProps<ZoomControllerProps>(), {
  minZoom: 0.5,
  maxZoom: 3,
  step: 0.25,
});

const emit = defineEmits<{
  'update:zoom': [value: number];
}>();

const canZoomIn = computed(() => props.zoom < props.maxZoom);
const canZoomOut = computed(() => props.zoom > props.minZoom);

const zoomIn = () => {
  emit('update:zoom', Math.min(props.maxZoom, props.zoom + props.step));
};

const zoomOut = () => {
  emit('update:zoom', Math.max(props.minZoom, props.zoom - props.step));
};
</script>

<template>
  <BaseButton
    type="primary"
    size="small"
    icon-name="minus"
    :state="canZoomOut ? 'default' : 'disabled'"
    @click="zoomOut"
  />
  <BaseButton
    type="primary"
    size="small"
    icon-name="plus"
    :state="canZoomIn ? 'default' : 'disabled'"
    @click="zoomIn"
  />
</template>
